module.exports = __webpack_public_path__ + "static/media/male_artwork.ba1458e4.svg";